import React, { useEffect, useState } from 'react';
import { getListTeamsByBounty } from '../../../../../redux/actions/daoUI/teamBounties.action';

const TeamsTab = ({ bounty, bountyId, activeTab }) => {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (activeTab === 'TEAMS') {
      const fetchTeams = async () => {
        setLoading(true);
        setError(null);
        try {
          const params = { bountyId };
          const response = await getListTeamsByBounty(params)();
          if (response) {
            setTeams(response.data?.teams || []);
          } else {
            setTeams([]);
          }
        } catch (err) {
          console.error('Error fetching teams:', err);
          setError('Failed to load teams');
          setTeams([]);
        } finally {
          setLoading(false);
        }
      };
      
      if (bountyId) fetchTeams();
    }
  }, [activeTab, bountyId]);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <h3 style={{ color: '#03edc3' }}>Users ({bounty?.name})</h3>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, background: '#fff', color: '#181c22', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px #0006' }}>
          <thead>
            <tr style={{ backgroundColor: '#f5f5f5' }}>
              <th style={{ padding: '14px', textAlign: 'left' }}>Team Name</th>
              <th style={{ padding: '14px', textAlign: 'left' }}>Introduction</th>
              <th style={{ padding: '14px', textAlign: 'left' }}>Leader Email</th>
              <th style={{ padding: '14px', textAlign: 'left' }}>Urgent Contact</th>
              <th style={{ padding: '14px', textAlign: 'left' }}>Challenge Topic</th>
              <th style={{ padding: '14px', textAlign: 'left' }}>Proposal Link</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} style={{ textAlign: 'center', color: '#888', padding: 24 }}>Loading...</td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan={6} style={{ textAlign: 'center', color: '#d32f2f', padding: 24 }}>{error}</td>
              </tr>
            ) : Array.isArray(teams) && teams.length > 0 ? (
              teams.map((team) => (
                <tr key={team._id || team.id || Math.random().toString()} style={{ cursor: 'pointer' }}>
                  <td style={{ padding: '12px' }}>{team.name}</td>
                  <td style={{ padding: '12px' }}>{team.introduction}</td>
                  <td style={{ padding: '12px' }}>{team.leaderEmail}</td>
                  <td style={{ padding: '12px' }}>{team.urgentContact}</td>
                  <td style={{ padding: '12px' }}>{team.challengeTopic}</td>
                  <td style={{ padding: '12px' }}>{team.proposalLink}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} style={{ textAlign: 'center', color: '#888', padding: 24 }}>No data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TeamsTab; 